import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {MvsCrudService} from 'features/core/shared/service/crud/mvs-crud.service';
import {
    HelpArticleCreateRequestDto,
    HelpArticleDto,
    HelpArticleFeedbackDto,
    HelpArticleUpdateRequestDto,
    HelpArticleVersionDto,
    HelpSearchResultDto
} from '../../model/dto/help-article.dto';

@Injectable({
    providedIn: 'root'
})
export class HelpArticleService {

    private readonly apiUrl: string;

    constructor(private http: HttpClient) {
        this.apiUrl = MvsCrudService.baseUrl + '/cb/help/articles';
    }

    listArticles(moduleAlias: string, status?: string): Observable<HelpArticleDto[]> {
        let params = new HttpParams().set('moduleAlias', moduleAlias);
        if (status) {
            params = params.set('status', status);
        }
        return this.http.get<HelpArticleDto[]>(this.apiUrl, {params});
    }

    getArticle(id: number): Observable<HelpArticleDto> {
        return this.http.get<HelpArticleDto>(`${this.apiUrl}/${id}`);
    }

    getArticleBySlug(slug: string): Observable<HelpArticleDto> {
        return this.http.get<HelpArticleDto>(`${this.apiUrl}/slug/${slug}`);
    }

    createArticle(request: HelpArticleCreateRequestDto): Observable<HelpArticleDto> {
        return this.http.post<HelpArticleDto>(this.apiUrl, request);
    }

    updateArticle(id: number, request: HelpArticleUpdateRequestDto): Observable<HelpArticleDto> {
        return this.http.put<HelpArticleDto>(`${this.apiUrl}/${id}`, request);
    }

    changeStatus(id: number, status: string): Observable<HelpArticleDto> {
        return this.http.post<HelpArticleDto>(`${this.apiUrl}/${id}/status`, null, {
            params: new HttpParams().set('status', status)
        });
    }

    publishArticle(id: number): Observable<HelpArticleDto> {
        return this.http.post<HelpArticleDto>(`${this.apiUrl}/${id}/publish`, null);
    }

    searchArticles(query: string, moduleAlias?: string): Observable<HelpSearchResultDto[]> {
        let params = new HttpParams().set('q', query);
        if (moduleAlias) {
            params = params.set('moduleAlias', moduleAlias);
        }
        return this.http.get<HelpSearchResultDto[]>(`${this.apiUrl}/search`, {params});
    }

    getPopularArticles(moduleAlias: string, limit: number = 5): Observable<HelpArticleDto[]> {
        const params = new HttpParams()
            .set('moduleAlias', moduleAlias)
            .set('limit', limit.toString());
        return this.http.get<HelpArticleDto[]>(`${this.apiUrl}/popular`, {params});
    }

    getRecentArticles(moduleAlias: string, limit: number = 5): Observable<HelpArticleDto[]> {
        const params = new HttpParams()
            .set('moduleAlias', moduleAlias)
            .set('limit', limit.toString());
        return this.http.get<HelpArticleDto[]>(`${this.apiUrl}/recent`, {params});
    }

    getVersionHistory(id: number): Observable<HelpArticleVersionDto[]> {
        return this.http.get<HelpArticleVersionDto[]>(`${this.apiUrl}/${id}/versions`);
    }

    submitFeedback(id: number, feedback: HelpArticleFeedbackDto): Observable<void> {
        return this.http.post<void>(`${this.apiUrl}/${id}/feedback`, feedback);
    }

    getRelatedArticles(id: number): Observable<HelpArticleDto[]> {
        return this.http.get<HelpArticleDto[]>(`${this.apiUrl}/${id}/related`);
    }
}
